export const channelType = (text?: string) => {
  switch (text) {
    case "channel-talk":
      return "채널톡";
    case "app-store":
      return "앱스토어";
    case "google-play":
      return "구글플레이";
    case "words":
    default:
      return "CSV";
  }
};
